// for toasts
import { toast } from "react-toastify";
import PropTypes from "prop-types";

// Config file
import { toastConfig } from "./constants";
import { format as fnsformat } from "date-fns";

const toastList = new Set();
const MAX_TOAST = 1;
const subsuer_api_regex = /^[a-zA-Z0-9]*$/;

export const toastSuccess = (message) => {
  if (toastList.size < MAX_TOAST) {
    const id = toast.success(message, {
      ...toastConfig,
      onClose: () => toastList.delete(id),
    });
    toastList.add(id);
  }
};

export const toastInfo = (message) => {
  if (toastList.size < MAX_TOAST) {
    const id = toast.info(message, {
      ...toastConfig,
      onClose: () => toastList.delete(id),
    });
    toastList.add(id);
  }
};

export const toastWarning = (message) => {
  if (toastList.size < MAX_TOAST) {
    const id = toast.warn(message, {
      ...toastConfig,
      onClose: () => toastList.delete(id),
    });
    toastList.add(id);
  }
};

export const toastError = (message) => {
  if (toastList.size < MAX_TOAST) {
    const id = toast.error(message, {
      ...toastConfig,
      onClose: () => toastList.delete(id),
    });
    toastList.add(id);
  }
};

export const convertKeyIntoNormal = key => {
  let output = key.replace(/(^|_)(\w)/g, function ($0, $1, $2) {
    return ($1 && ' ') + $2.toUpperCase();
  });
  return output
}

export const toastDefault = (message) => {
  if (toastList.size < MAX_TOAST) {
    const id = toast(message, {
      ...toastConfig,
      onClose: () => toastList.delete(id),
    });
    toastList.add(id);
  }
};

const demo = (sts) => {
  return sts;
};

export const MerchantURl = () => {
  const current_domain = window.location.hostname; 
  const env_data = process.env.REACT_APP_STATUS
  let merchant_type
  if(env_data == "Test"){
     merchant_type = current_domain.split('.')[2];
  }
  else{
      merchant_type = current_domain.split('.')[1];
  }
  return merchant_type;
}

export const queryStringParsar = (qString) => {
  let parsed = {};

  if (!!qString) {
    const cleanString = qString.startsWith("?") ? qString.slice(1) : qString;
    const params = new URLSearchParams(cleanString);

    for (const [key, value] of params.entries()) {
      if (!!key && !!value) {
        parsed[key] = value;
      }
    }
  }
  return parsed;
};

export const DateHandle = (e) => {
  let date = JSON.stringify(e);
  const date_array = date.split(" ");
  const date_format = date_array[0].split("T");
  return date_format[0].replace(/["]/g, "");
};


var strTime = '';
export const formatDate = (dates) => {
  let datetime = new Date(dates);
  var hours = datetime.getHours();
  var minutes = datetime.getMinutes();
  var seconds = datetime.getSeconds();
  // var ampm = hours >= 12 ? "pm" : "am";
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var year = datetime.getFullYear();
  var month = datetime.getMonth();
  month = month < 10 ? "0" + month : month;
  var date = datetime.getDate();
  date = date < 10 ? "0" + date : date;
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  var strTime =
    year +
    "-" +
    month +
    "-" +
    date +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds;
  return strTime;
};
export const readableFormatDate = (dates) => {
  if (!dates) return "-";
  let dt = new Date(dates);
  if (isNaN(dt)) {
    return '-'
  }
  return fnsformat(dt, "do MMMM yyyy hh:mm:ss a");
};

export const readableDate = (dates) => {
  if (!dates) return "-";
  let dt = new Date(dates);
  if (isNaN(dt)) {
    return '-'
  }
  return fnsformat(dt, "do MMMM yyyy");
};

const Customformat = new Intl.NumberFormat("en-us", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 2,
});

export const formatCurrency = (amount, skip) => {
  if (skip) {
    amount = Number(amount);
    return Customformat.format(amount);
  }
  if (amount) {
    amount = Number(amount);
  } else {
    return "-";
  }
  return Customformat.format(amount);
};

export const isObject = (o) => {
  return o !== null && typeof o === "object" && Array.isArray(o) === false;
};

export const nullToDash = (data) => {
  if (Array.isArray(data)) {
    return data.map((value) => {
      if (Array.isArray(value) || isObject(value)) return nullToDash(value);
      return value === null ? "-" : value;
    });
  } else if (isObject(data)) {
    for (var key in data) {
      if (data.hasOwnProperty(key)) {
        if (Array.isArray(data[key]) || isObject(data[key])) {
          data[key] = nullToDash(data[key]);
        } else {
          data[key] = data[key] === null ? "-" : data[key];
        }
      }
    }
  }
  return data;
};

/**
 *
 * @param {itemKey is data }
 * @param {value is key }
 */
export const IsEmpty = ({ itemKey, value }) => {
  return itemKey &&
    itemKey.hasOwnProperty(value) &&
    itemKey[value] !== "" &&
    itemKey[value] !== null
    ? itemKey[value]
    : "-";
};

export const hasRoutePermission = (route, role, permission) => {
  if (role && role['role_id'] && role['role_id'] === 1) return true;
  if (role &&
    role["permission"][route] &&
    role["permission"][route].find((value) => value === permission)
  ) {
    return true;
  }

  return false;
};
export const openPaymentlink = (link) => {
  window.open(link, "_blank");
};
export const encodedUrl = (data) => {
  return encodeURIComponent(data)
};


const addZero = (str) => {
  if (String(str).length === 1) {
    return `0${str}`;
  }
  return str;
};
export const formatApiDate = (date) => {
  if (!date) return "-";
  let d = new Date(date);

  return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(
    d.getDate()
  )} ${addZero(d.getHours())}:${addZero(d.getMinutes())}:${addZero(
    d.getSeconds()
  )}`;
};

export const formatDateinHr = (date) => {
  if (!date) return "";
  let d = new Date(date);

  return `${d.getFullYear()}-${addZero(d.getMonth() + 1)}-${addZero(
    d.getDate()
  )} ${addZero(d.getHours())}:${addZero(d.getMinutes())}`;
};

export const queryparamBuilder = (param = {}) => {
  let str = "";
  if (!Object.keys(param).length) return str;

  for (const key in param) {
    if (param.hasOwnProperty(key)) {
      if (param[key] === 0 || param[key]) {
        str += `${key}=${param[key]}&`;
      }
    }
  }
  return str;
};

export const getFullAddress = (address) => {
  const { room_number, line_1, line_2, landmark, pincode, city } = address;
  let str = "";
  if (room_number) {
    str = str.concat(room_number + ',');
  }
  if (line_1) {
    str = str.concat(line_1 + ',');
  }
  if (line_2) {
    str = str.concat(line_2 + ',');
  }
  if (landmark) {
    str = str.concat(landmark + ',');
  }
  if (city) {
    str = str.concat(city + ',');
  }
  if (pincode) {
    str = str.concat(pincode + ',');
  }
  return str;
};
export const convertNumberIntoDesiredLength = (number, desiredLength) => {
  var str = "" + number;
  if (str.length < desiredLength) str = new Array(desiredLength - str.length).join("0") + str;
  return str;
}
export const filterValidation = (selected,value) => {
  let error_message = "";
  const email_regex =  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  let mobile_number_regex = /^[6789]\d{9}$/;
  let pan_number_regex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  let refrence_number_regex = /^([a-zA-Z0-9_-]){20}$/
  let ifsc_code_regex = /^[A-Z]{4}0[A-Z0-9]{6}$/
  let bank_account_regex =/^[0-9]{9,18}$/
  let name_regex = /^([a-zA-Z ]){1,30}$/
  let pincode_regex = /^\d{6}$/
  let id_regex = /^\d{1,20}$/
  let utr_regex = /^[0-9]{1,40}$/
  let regexp =/^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/

  switch (selected) {
      case "name":
      case "user_name":
      case "bank_name":
        if((value== ""|| !name_regex.test(value)  || !regexp.test(value))){
          error_message= "Please enter valid Name."
        }
        break;
      case "role_id":
      case "repeat_first_offer_id" :
      case "user_id" :
      case "pg_refund_reference_number":
      case "merchant_id":
      case "utr_no" :
        if((value== ""|| !id_regex.test(value))){
          error_message= "Please enter valid id."
        }
        break;
      case "mobile_number":
      case "phone_number" :
        if ((value== "" || !mobile_number_regex.test(value))) {
          error_message= "Please enter valid mobile";
        }
        break;
      case "email":
        if((value== ""|| !email_regex.test(value))){
          error_message= "Please enter valid Email."
        }
        break;
      case "pan": 
        if(value == "" || !pan_number_regex.test(value))
        {
          error_message= "Please enter valid pan number."
        }
        break;
      case "bank_account_no":
        if(value == "" || !bank_account_regex.test(value))
        {
          error_message= "Please enter valid account number."
        }
        break;
      case "bank_branch_ifsc":
        if(value == "" || !ifsc_code_regex.test(value))
        {
          error_message= "Please enter valid ifsc number."
        }
        break;
      case "pincode":
        if(value == "" || !pincode_regex.test(value))
        {
          error_message= "Please enter valid pincode number."
        }
        break;
      case "utr_number":
        if(value == "" || !utr_regex.test(value))
        {
          error_message= "Please enter valid utr number."
        }
        break;         
      case "user_reference_number":
      case "transaction_reference_number" :
      case "loan_reference_number" :
      case "payment_reference_number" :
      case "subuser_payment_reference_number" :
      case "search_by_subuser" :
      case "bank_deposit_reference_number":
      case "deposited_by_reference_number":
      case "verified_by_subuser":
      case "refund_reference_number":
      case "subuser_reference_number":
      case "source_reference_number" :
      case "disbursement_reference_number":
      case "outbound_reference_number":
      case "merchant_order_id":
        if(value == "" || !refrence_number_regex.test(value) )
        {
          error_message= "Please enter valid refrence number."
        }
    }
  return error_message;
}


export const validateInputValue =(inputValue, callback) => {
  const trimmed_value = inputValue.trim();
  if (subsuer_api_regex.test(trimmed_value)) {
    callback(trimmed_value);
  }
}


export default {
  queryStringParsar,
  toastDefault,
  toastError,
  toastWarning,
  toastInfo,
  toastSuccess,
  formatDate,
  formatCurrency,
};
hasRoutePermission.propTypes = {
  route: PropTypes.string,
  role: PropTypes.any,
  permission: PropTypes.string,
};
formatCurrency.propTypes = {
  amount: PropTypes.any,
  skip: PropTypes.bool,
};
